import React, { useState, useEffect, useRef } from 'react';

interface LazyImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  skeleton?: string;
}

const LazyImage: React.FC<LazyImageProps> = ({
  src,
  alt,
  skeleton,
  ...props
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const imgRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    const imgElement = imgRef.current; // Store ref value in a variable

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (imgElement) {
              imgElement.src = src;
            }
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '100px 0px', threshold: 0 }
    );

    if (imgElement) {
      observer.observe(imgElement);
    }

    return () => {
      if (imgElement) {
        observer.unobserve(imgElement);
      }
    };
  }, [src]);

  return (
    <>
      {!isLoaded && <div className={skeleton}></div>}
      <img
        ref={imgRef}
        alt={alt}
        {...props}
        onLoad={() => setIsLoaded(true)}
        style={{
          opacity: isLoaded ? 1 : 0,
          transition: 'all 0.3s ease-in-out',
        }}
      />
    </>
  );
};

export default LazyImage;
